<ng-container *ngIf="!skip; else unsupportedPlan">
    <div class="change-contact-step-content has-border padded-row">
        <ng-container *ngIf="cellularDevice; else loadingSpinner">
            <ng-container [ngSwitch]="lteStatus">
                <div *ngSwitchCase="'INCOMPLETE'" class="cellular-edit-form">
                    <clare-cellular-edit
                        [address]="address$ | async"
                        [dbSecurityDevice]="dbSecurityDevice"
                        [device]="cellularDevice"
                        [disableSubmit]="cellularProviderAction === 'Send Provider Update to Panel' && !chSecurityDevice"
                        [cellProviderOnPanel]="providerOnPanel"
                        [cellularProviderAction]="cellularProviderAction"
                        [chDeviceIccid]="chSecurityDevice?.Properties.ICCID"
                        [config]="cellularEditConfig"
                        [isCellActive]="!isLteDisabled"
                        [isProjectOnline]="!!chSecurityDevice"
                        [defaultProviderOverride]="defaultProviderOverride"
                        [submissionStatus]="submissionStatus"
                        [errors]="submissionErrors"
                        (triggerCellularAction)="onCellularAction($event)"
                        (updateProvider)="updateProvider($event, chSecurityDevice)"
                        (updateProviderAction)="onUpdateProviderAction()"
                        (providerSelection)="onUpdateProviderAction($event)"
                    ></clare-cellular-edit>
                </div>
                <span *ngSwitchCase="'COMPLETE'">LTE enabled on the new panel.</span>
                <span *ngSwitchDefault>
                    <clare-spinner text="LTE is {{ cellularDevice.status }}" textAlign="left"></clare-spinner>
                </span>
            </ng-container>
        </ng-container>
    </div>
</ng-container>

<ng-template #unsupportedPlan>
    <div class="has-border padded-row" fxLayout="column" fxLayoutGap="0.5rem">
        <p>Proceed to the next step as this account does not have a service plan with LTE.</p>
        <p><i>For more information regarding this account's plan, visit the Service Plans section after Replace Panel is complete.</i></p>
    </div>
</ng-template>

<ng-template #loadingSpinner>
    <clare-spinner text="Retrieving LTE status" textAlign="left"></clare-spinner>
</ng-template>
